function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetpassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  home: path(ROOTS_DASHBOARD, '/home'),
  underconstruction: path(ROOTS_DASHBOARD, '/underconstruction'),
  brand: (name) => path(ROOTS_DASHBOARD, `/brand/${name}`),
  one: path(ROOTS_DASHBOARD, '/one'),
  AI: {
    root: path(ROOTS_DASHBOARD, '/AI'),
    AiDashboard: path(ROOTS_DASHBOARD, '/AI/AiDashboard'),
    SetThreshold: path(ROOTS_DASHBOARD, '/AI/SetThreshold'),
  },
  // brand: {
  //   root: path(ROOTS_DASHBOARD, `/brand`),
  //   name: (name) => path(ROOTS_DASHBOARD, `/brand/${name}`),
  // },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    usersList: path(ROOTS_DASHBOARD, '/user/usersList'),
    changePassword: path(ROOTS_DASHBOARD, '/user/changePassword'),
    accessSetPassword: path(ROOTS_DASHBOARD, '/user/accessSetPassword'),
    userRole: path(ROOTS_DASHBOARD, '/user/userRole'),
    accessLevel: path(ROOTS_DASHBOARD, '/user/accessLevel'),
    one: path(ROOTS_DASHBOARD, `/user/one`),
  },

  UploadF: {
    root: path(ROOTS_DASHBOARD, '/UploadF'),
    DepFile: path(ROOTS_DASHBOARD, '/UploadF/DepFile'),
    LoanFile: path(ROOTS_DASHBOARD, '/UploadF/LoanFile'),
    WarrFile: path(ROOTS_DASHBOARD, '/UploadF/WarrFile'),
  },

  depfile: {
    root: path(ROOTS_DASHBOARD, '/depFile'),
    MavadDepFile: path(ROOTS_DASHBOARD, '/depFile/MavadDepFile'),
    MahsoolDepFile: path(ROOTS_DASHBOARD, '/depFile/MahsoolDepFile'),
    SellMDepFile: path(ROOTS_DASHBOARD, '/depFile/SellMDepFile'),
    CIFDepFile: path(ROOTS_DASHBOARD, '/depFile/CIFDepFile'),
    TaminDepFile: path(ROOTS_DASHBOARD, '/depFile/TaminDepFile'),
  },

  depFile: {
    root: path(ROOTS_DASHBOARD, '/depFile'),
    MavadDepFile: path(ROOTS_DASHBOARD, '/depFile/MavadDepFile'),
    MahsoolDepFile: path(ROOTS_DASHBOARD, '/depFile/MahsoolDepFile'),
    SellMDepFile: path(ROOTS_DASHBOARD, '/depFile/SellMDepFile'),
    CIFDepFile: path(ROOTS_DASHBOARD, '/depFile/CIFDepFile'),
    TaminDepFile: path(ROOTS_DASHBOARD, '/depFile/TaminDepFile'),
  },




  MAMA: {
    root: path(ROOTS_DASHBOARD, '/MAMA'),
    regMama: path(ROOTS_DASHBOARD, '/MAMA/regMama'),
    tasvibMama: path(ROOTS_DASHBOARD, '/MAMA/tasvibMama'),
    tahaghoghMama: path(ROOTS_DASHBOARD, '/MAMA/tahaghoghMama'),
    MamaRpt: path(ROOTS_DASHBOARD, '/MAMA/MamaRpt'),
    MAMADash: path(ROOTS_DASHBOARD, '/MAMA/MAMADash'),
    MamaRptEnheraf: path(ROOTS_DASHBOARD, '/MAMA/MamaRptEnheraf'),
  },

  TRAN: {
    root: path(ROOTS_DASHBOARD, '/TRAN'),
    AccountTemplate: path(ROOTS_DASHBOARD, '/TRAN/AccountTemplate'),
    AccountAWCTemplate: path(ROOTS_DASHBOARD, '/TRAN/AccountAWCTemplate'),
    AccountAWC: path(ROOTS_DASHBOARD, '/TRAN/AccountAWC'),
    AccountTAWC: path(ROOTS_DASHBOARD, '/TRAN/AccountTAWC'),
    AccountTRAN: path(ROOTS_DASHBOARD, '/TRAN/AccountTRAN'),
  },




  HoldingR: {
    root: path(ROOTS_DASHBOARD, '/HoldingR'),
    Holding: path(ROOTS_DASHBOARD, '/HoldingR/Holding'),
    HoldingBase: path(ROOTS_DASHBOARD, '/HoldingR/HoldingBase'),
  },
  BankManagement: {
    root: path(ROOTS_DASHBOARD, '/BankManagement'),
    Bank: path(ROOTS_DASHBOARD, '/BankManagement/Bank'),

    BankBenefitCompany: path(ROOTS_DASHBOARD, '/BankManagement/BankBenefitCompany'),
    CurrentBalanceChartCompany: path(ROOTS_DASHBOARD, '/BankManagement/CurrentBalanceChartCompany'),
    AvrageTrend: path(ROOTS_DASHBOARD, '/BankManagement/AvrageTrend'),
    LoanTrend: path(ROOTS_DASHBOARD, '/BankManagement/LoanTrend'),
    WarrTrend: path(ROOTS_DASHBOARD, '/BankManagement/WarrTrend'),
    PersenelTrend: path(ROOTS_DASHBOARD, '/BankManagement/PersenelTrend'),
  },
  CompanyR: {
    root: path(ROOTS_DASHBOARD, '/CompanyR'),
    Company: path(ROOTS_DASHBOARD, '/CompanyR/Company'),

    BankBenefit: path(ROOTS_DASHBOARD, '/CompanyR/BankBenefit'),
    CurrentBalanceChart: path(ROOTS_DASHBOARD, '/CompanyR/CurrentBalanceChart'),
    Avrage: path(ROOTS_DASHBOARD, '/CompanyR/Avrage'),
    Loan: path(ROOTS_DASHBOARD, '/CompanyR/Loan'),
    Warr: path(ROOTS_DASHBOARD, '/CompanyR/Warr'),
    Persenel: path(ROOTS_DASHBOARD, '/CompanyR/Persenel'),
  },
  dataEntry: {
    root: path(ROOTS_DASHBOARD, '/dataEntry'),
    accountInfo: path(ROOTS_DASHBOARD, '/dataEntry/accountInfo'),
    amountInfo: path(ROOTS_DASHBOARD, '/dataEntry/amountInfo'),
    loanInfo: path(ROOTS_DASHBOARD, '/dataEntry/loanInfo'),
    warrInfo: path(ROOTS_DASHBOARD, '/dataEntry/warrInfo'),
    approvalsInfo: path(ROOTS_DASHBOARD, '/dataEntry/approvalsInfo'),
  },

  supplier: {
    root: path(ROOTS_DASHBOARD, '/supplier'),
    supplierIntroduction: path(ROOTS_DASHBOARD, '/supplier/supplierIntroduction'),
    one: path(ROOTS_DASHBOARD, `/supplier/one`),
  },
  shopper: {
    root: path(ROOTS_DASHBOARD, '/shopper'),
    buyerIntroduction: path(ROOTS_DASHBOARD, '/shopper/buyerIntroduction'),
    one: path(ROOTS_DASHBOARD, `/shopper/one`),
  },
  broker: {
    root: path(ROOTS_DASHBOARD, '/broker'),
    one: path(ROOTS_DASHBOARD, `/broker/one`),
  },
  goods: {
    root: path(ROOTS_DASHBOARD, '/goods'),
    goodsSearch: path(ROOTS_DASHBOARD, '/goods/goodsSearch'),
    prdmList: path(ROOTS_DASHBOARD, '/goods/prdmList'),
    levelList: path(ROOTS_DASHBOARD, '/goods/levelList'),
    one: path(ROOTS_DASHBOARD, `/goods/one`),
  },
  wage: {
    root: path(ROOTS_DASHBOARD, '/wage'),
    one: path(ROOTS_DASHBOARD, `/wage/one`),
  },
  supply: {
    root: path(ROOTS_DASHBOARD, '/supply'),
    setSUPM: path(ROOTS_DASHBOARD, `/supply/setSUPM`),
    updateTRDM: path(ROOTS_DASHBOARD, `/supply/updateTRDM`),
    edit: (id) => path(ROOTS_DASHBOARD, `/supply/${id}/edit`),
    supplyGroup: path(ROOTS_DASHBOARD, `/supply/supplyGroup`),
    one: path(ROOTS_DASHBOARD, `/supply/one`),
  },
  order: {
    root: path(ROOTS_DASHBOARD, '/order'),
    one: path(ROOTS_DASHBOARD, `/order/one`),
  },
  ordering: {
    root: path(ROOTS_DASHBOARD, '/ordering'),
    orderGeneralList: path(ROOTS_DASHBOARD, '/ordering/orderGeneralList'),
    orderList: path(ROOTS_DASHBOARD, '/ordering/orderList'),
    view: (id) => path(ROOTS_DASHBOARD, `/ordering/${id}`),
    viewg: (id) => path(ROOTS_DASHBOARD, `/ordering/${id}/view`),
    registrationOrder: path(ROOTS_DASHBOARD, '/ordering/registrationOrder'),
    checkout: path(ROOTS_DASHBOARD, '/ordering/checkout'),
    one: path(ROOTS_DASHBOARD, `/ordering/one`),
  },
  payment: {
    root: path(ROOTS_DASHBOARD, '/payment'),
    depositList: path(ROOTS_DASHBOARD, '/payment/depositList'),
    depositGeneralList: path(ROOTS_DASHBOARD, '/payment/depositGeneralList'),
    view: (id) => path(ROOTS_DASHBOARD, `/payment/${id}`),
    add: (id) => path(ROOTS_DASHBOARD, `/payment/${id}/add`),
    edit: (id) => path(ROOTS_DASHBOARD, `/payment/${id}/edit`),
  },
  report: {
    root: path(ROOTS_DASHBOARD, '/report'),
    onlineAccountBalance: path(ROOTS_DASHBOARD, '/report/onlineAccountBalance'),
    accountBalance: path(ROOTS_DASHBOARD, '/report/accountBalance'),
    averageReport: path(ROOTS_DASHBOARD, '/report/averageReport'),
    accountList: path(ROOTS_DASHBOARD, '/report/accountList'),
    accountGeneralList: path(ROOTS_DASHBOARD, '/report/accountGeneralList'),
    one: path(ROOTS_DASHBOARD, `/report/one`),
  },
  price: {
    root: path(ROOTS_DASHBOARD, '/price'),
    supplyBoard: path(ROOTS_DASHBOARD, '/price/supplyBoard'),
    one: path(ROOTS_DASHBOARD, `/price/one`),
  },
  financial: {
    root: path(ROOTS_DASHBOARD, '/financial'),
    cifAccountList: path(ROOTS_DASHBOARD, `/financial/cifAccountList`),
    manualAdd: path(ROOTS_DASHBOARD, `/financial/manualAdd`),
    one: path(ROOTS_DASHBOARD, `/financial/one`),
  },
  transport: {
    root: path(ROOTS_DASHBOARD, '/transport'),
    transportList: path(ROOTS_DASHBOARD, `/transport/transportList`),
    one: path(ROOTS_DASHBOARD, `/transport/one`),
  },
  mavad: {
    root: path(ROOTS_DASHBOARD, '/mavad'),
    mavadGeneral: path(ROOTS_DASHBOARD, `/mavad/mavadGeneral`),
    mavad: path(ROOTS_DASHBOARD, `/mavad/mavad`),
    mavadReport: path(ROOTS_DASHBOARD, `/mavad/mavadReport`),
    mavadDeadStock: path(ROOTS_DASHBOARD, `/mavad/mavadDeadStock`),
    edit: (idIN) => path(ROOTS_DASHBOARD, `/mavad/${idIN}/edit`),
  },
  tamink: {
    root: path(ROOTS_DASHBOARD, '/tamink'),
    TaminkReport: path(ROOTS_DASHBOARD, `/tamink/TaminkReport`),
    Tamink: path(ROOTS_DASHBOARD, `/tamink/Tamink`),
    TaminkAll: path(ROOTS_DASHBOARD, `/tamink/TaminkAll`),
    KharidReport: path(ROOTS_DASHBOARD, `/tamink/KharidReport`),
    edit: (idIN) => path(ROOTS_DASHBOARD, `/tamink/${idIN}/edit`),
  },
  SellM: {
    root: path(ROOTS_DASHBOARD, '/SellM'),
    SellM: path(ROOTS_DASHBOARD, `/SellM/SellM`),
    SellAll: path(ROOTS_DASHBOARD, `/SellM/SellAll`),
    SellTrend: path(ROOTS_DASHBOARD, `/SellM/SellTrend`),
    SellByProduct: path(ROOTS_DASHBOARD, `/SellM/SellByProduct`),
    SellForecast: path(ROOTS_DASHBOARD, `/SellM/SellForecast`),
  },
  CIFM: {
    root: path(ROOTS_DASHBOARD, '/CIFM'),
    CIFRpt: path(ROOTS_DASHBOARD, `/CIFM/CIFRpt`),
    CifAll: path(ROOTS_DASHBOARD, `/CIFM/CifAll`),
    CifCluster: path(ROOTS_DASHBOARD, `/CIFM/CifCluster`),
    CifProfile: path(ROOTS_DASHBOARD, `/CIFM/CifProfile`),
    CallRpt: path(ROOTS_DASHBOARD, `/CIFM/CallRpt`),
    edit: (idIN) => path(ROOTS_DASHBOARD, `/CIFM/${idIN}/edit`),
  },
  tolid: {
    root: path(ROOTS_DASHBOARD, '/tolid'),
    tolidReport: path(ROOTS_DASHBOARD, `/tolid/tolidReport`),
    tolidGeneral: path(ROOTS_DASHBOARD, `/tolid/tolidGeneral`),
    tolidTrend: path(ROOTS_DASHBOARD, `/tolid/tolidTrend`),
    tolidTafkik: path(ROOTS_DASHBOARD, `/tolid/tolidTafkik`),
  },


  ProductR: {
    root: path(ROOTS_DASHBOARD, '/ProductR'),
    Product: path(ROOTS_DASHBOARD, '/ProductR/Product'),
    ProductRpt: path(ROOTS_DASHBOARD, '/ProductR/ProductRpt'),
    ProductD: path(ROOTS_DASHBOARD, '/ProductR/ProductD'),
    DeadstockProducts: path(ROOTS_DASHBOARD, '/ProductR/DeadstockProducts'),
    edit: (idIN) => path(ROOTS_DASHBOARD, `/ProductR/${idIN}/edit`),

  },

  Report: {
    root: path(ROOTS_DASHBOARD, '/Report'),
    GlucAll: path(ROOTS_DASHBOARD, '/Report/GlucAll'),
  },

  HR: {
    root: path(ROOTS_DASHBOARD, '/HR'),
    HRRpt: path(ROOTS_DASHBOARD, '/HR/HRRpt'),
    HRProfile: path(ROOTS_DASHBOARD, '/HR/HRProfile'),
    edit: (idIN) => path(ROOTS_DASHBOARD, `/HR/${idIN}/edit`),
  },
  BaseD: {
    root: path(ROOTS_DASHBOARD, '/BaseD'),
    ProductList: path(ROOTS_DASHBOARD, '/BaseD/ProductList'),
  },
  logistics: {
    root: path(ROOTS_DASHBOARD, '/logistics'),
    trafficRpt: path(ROOTS_DASHBOARD, `/logistics/trafficRpt`),
    taradodRpt: path(ROOTS_DASHBOARD, `/logistics/taradodRpt`),
    vehicleCatList: path(ROOTS_DASHBOARD, `/logistics/vehicleCatList`),
    vehicleList: path(ROOTS_DASHBOARD, `/logistics/vehicleList`),
    vehicleD: path(ROOTS_DASHBOARD, `/logistics/vehicleD`),
    edit: (pelak) => path(ROOTS_DASHBOARD, `/logistics/${pelak}/edit`),
  }

  // xxxx: {
  //   root: path(ROOTS_DASHBOARD, '/xxxx'),
  //   one: path(ROOTS_DASHBOARD, `/xxxx/one`),
  // },
};
